import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import { getSellableProducts } from 'actions/EntityActions';
// Basic Components
import Button from 'screens/components/basic/Button';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose'
import DecimalInput from 'screens/components/basic/DecimalInput';
// Advanced Components
import DialogInput from 'screens/components/advanced/DialogInput';

const dialogStyle = {
    width: '65%',
    maxWidth: 'none'
};
class POSVariableGiftCardDialog extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            dialog: true
        };
    }

    componentWillReceiveProps(newProps) {
        if (newProps.open && newProps.open !== this.props.open) {
            this.search();
        }
    }

    search = () => {
        const filters = {
            page: 1,
            itemsPerPage: 1,
            searchText: this.props.t('pos.variableGiftCardDialog.giftCardAmount'),
            baseCategoryId: "3",
            categoryId: null,
            branchId: this.props.branchId,
            THC_MIN: 0,
            THC_MAX: 100,
            CBD_MIN: 0,
            CBD_MAX: 100,
            SubCategoryId: [],
            Weight: []
        };

        this.props.getProducts(filters);
    }

    confirm = (productId) => {
        if (productId > 0) {
            this.props.addProductToPOSOder({
                id: 0,
                productId: productId,
                quantity: 1,
                isManuallyInputted: true,
                packageReference: "",
                isCannabis: false,
                price: this.props.variableGiftCardAmount
            });
        }
        this.props.onClose();
    }

    render() {
        const { t } = this.props; 
        const p = this.props;
        let productFound = p.sellableProducts && p.sellableProducts.filter(p => p.name == t('pos.variableGiftCardDialog.giftCardAmount')).length > 0 ? p.sellableProducts.filter(p => p.name == t('pos.variableGiftCardDialog.giftCardAmount'))[0] : null;

        return (
            <div>
                <DialogInput
                    title={<DialogHeaderWithClose text={t('pos.variableGiftCardDialog.addGiftCardToOrder')} handleClose={() => this.props.onClose()} />}
                    modal={true}
                    open={p.open && this.state.dialog}
                    autoScrollBodyContent={true}
                    style={{ zIndex: '980' }}
                    actions={[
                        <Button
                            key={1}
                            type="CancelButton"
                            name="buttonClose"
                            className="btn-space"
                            label={t('common.close')}
                            onTouchTap={() => this.props.onClose()} />,
                        <Button
                            key={2}
                            className="pull-right space btnNewBrandPOS"
                            name="buttonRefundDialogConfirm"
                            label={t('common.confirmUpper')}
                            primary={true}
                            onTouchTap={() => this.confirm(productFound ? productFound.id : 0)} />]}
                    contentStyle={dialogStyle}>
                    <div className="row">
                        <div className="col-lg-12">
                            {
                                productFound ?
                                    <div>
                                        <p className="alert alert-warning">
                                            {t('pos.variableGiftCardDialog.inputGiftCardAmount')}
                                        </p>
                                        <div className="col-lg-12">
                                            <DecimalInput name={`variableGiftCardAmount`}
                                                fullWidth={true}
                                                label={t('pos.variableGiftCardDialog.variableGiftCardAmount')}
                                                floatingLabelText={t('pos.variableGiftCardDialog.variableGiftCardAmount')}
                                                hintText={t('pos.variableGiftCardDialog.variableGiftCardAmount')} />
                                        </div>
                                    </div>
                                    :
                                    <p className="alert alert-warning">
                                        {t('pos.variableGiftCardDialog.noProductFound', { amount: t('pos.variableGiftCardDialog.giftCardAmount')})}
                                    </p>
                            }

                        </div>
                    </div>
                </DialogInput>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        branchId: state.common.branchId,
        sellableProducts: state.entity.sellableProducts || [],
        variableGiftCardAmount: state.form.variableGiftCardAmount
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getProducts: (filters) => dispatch(getSellableProducts(filters)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSVariableGiftCardDialog))